import React from 'react';

const STAR_POSITIONS = [
  [120, 28], [260, 14], [430, 36], [570, 22], [720, 12],
  [880, 30], [1040, 18], [1230, 28], [1400, 14], [1520, 32],
];

const SkylineStars = ({ accent }) => (
  <g fill={accent}>
    {STAR_POSITIONS.map(([cx, cy], i) => (
      <circle
        key={`city-1-${i}`}
        className="cs-star"
        cx={cx}
        cy={cy}
        r="1.4"
        style={{ animationDelay: `${i * 410}ms` }}
      />
    ))}
  </g>
);

export default SkylineStars;
